import { render, staticRenderFns } from "./LbCriteriaLookup.vue?vue&type=template&id=3f318dce&lang=pug"
import script from "./LbCriteriaLookup.vue?vue&type=script&lang=js"
export * from "./LbCriteriaLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports